<template>
  <div id="pois" class="pois" v-if="pois && Object.keys(pois).length !== 0">
    <div class="content">
    <h2>Nearby points of interest</h2>
    <ul>
      <li v-for="(poi, i) in Object.entries(pois)[0][1]" :key="i">
        <a class="title" v-if="poi.link_enabled" :href="'/poi/'+poi.slug">{{poi.name}}</a>
        <p class="title" v-else>{{poi.name}}</p>
        <p v-if="poi.sdesc" v-html="poi.sdesc"></p>
      </li>
    </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pois: Object
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';
.pois {
  margin: 0 1.25rem 1.25rem;
  
  @media #{$desktop} {
    margin: 0;
  }
}
  
h2 {
  font-size: 1.25rem;
  line-height: 1.25rem;
  margin: 1.25rem 0;
  @media #{$desktop} {
    font-size: 1.5rem;
    line-height: 1.813rem;
  }
}

.content {
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #D9D9D9;

  a,p {
    font-size: .875rem;
    line-height: 1.125rem;
    @media #{$desktop} {
     font-size: 1rem;
     line-height: 1.25rem;
    } 
  }
}

.title {
  font-weight: bold;
  margin: 0 0 .65rem 0;
  display: block;
}
ul {
  list-style: none;
}
li {
  margin: 0 0 0.65rem 0;
}
</style>